export default __webpack_public_path__ + "static/9-9e21fc19353b72ccd372943622e56820.png";